/**
 * @author Jersson Stiven Morales Alza
 * @Copyright (c) Infotrack. All rights reserved.
 */
export default {
    'sidebar.smartstock': 'Clientes',
    'sidebar.clientes': 'Clientes',
    'clientes.agregarClientes': 'Crear Clientes',
    'clientes.modificarClientes': 'Editar Clientes',
    'clientes.clienteId': 'Cliente Id',
    'clientes.empresaId': 'Empresa Id',
    'clientes.descripcionCliente': 'Descripción',
    'clientes.descripcionSucursal': 'Descripción Sucursal',
    'clientes.descripcionTipoCliente': 'Tipo cliente',
    'clientes.diasVencimiento': 'Días vencimiento',
    'clientes.documento': 'Documento',
    'clientes.descripcionCiudad': 'Ciudad',
    'clientes.tipoClienteId': 'Tipo Cliente',
    'clientes.ciudadId': 'Ciudad',
    'clientes.nombreContacto': 'Nombre Contacto',
    'clientes.telefono': 'Teléfono',
    'clientes.direccion': 'Dirección',
    'clientes.correo': 'Correo',
    'clientes.codigoBarras': 'Código Barras',
    'clientes.principal': 'Principal',
    'clientes.estado': 'Estado',
    'clientes.clienteSeleccionado': 'Cliente',
    'clientes.seleccionarCliente': 'Seleccionar cliente',
    'clientes.verClientes': 'Ver Clientes',
    'clientes.mensaje.municipiosNoEncontrados': 'No se encontraron ciudades',
    'clientes.alerta.correoInvalido': 'El correo ingresado no es válido',
    'clientes.alerta.eliminarClientePrincipal':
        '¿Está seguro que desea eliminar este cliente, se eliminarán todas las sucursales asociadas?',
    'clientes.TipoClienteInactivo': 'Registro tipo cliente inactivo, seleccione uno nuevo',
};
